module.exports = __webpack_public_path__ + "static/media/SHAYMAA WALID TARIFI.b5563277.png";